// Site-wide content: shared by the header, footer and metadata.
// PLACEHOLDER: names, descriptions and links are not decided yet.

export interface NavLink {
  label: string;
  href: string;
}

export interface ServiceSummary extends NavLink {
  slug: string;
  description: string;
}

export interface SocialLink {
  label: string;
  href: string;
  icon: "x" | "linkedin" | "github";
}

// PLACEHOLDER services
export const services: ServiceSummary[] = [
  {
    slug: "ai-strategy",
    label: "AI strategy and roadmap",
    href: "/services/ai-strategy",
    description: "Find where AI will save you the most time and money, and get a clear plan.",
  },
  {
    slug: "workflow-automation",
    label: "Workflow automation",
    href: "/services/workflow-automation",
    description: "Replace repetitive admin in sales, finance and support with reliable automations.",
  },
  {
    slug: "custom-ai-assistants",
    label: "Custom AI assistants",
    href: "/services/custom-ai-assistants",
    description: "Assistants trained on your own documents to help customers and staff.",
  },
];

export const site = {
  name: "Dawsco",
  copyrightYear: 2026, // static: a build-time Date() breaks prerendering in Next 16
  tagline: "Practical AI for small businesses",
  // PLACEHOLDER
  description:
    "Dawsco helps small and mid-sized businesses save time with practical AI: strategy, automation and a ready-made AI assistant. Talk to us about your first project.",
  cta: { label: "Talk to us", href: "/contact" } satisfies NavLink,
  allServices: { label: "All services", href: "/services" } satisfies NavLink,

  nav: [
    { label: "Product", href: "/product" },
    { label: "Pricing", href: "/pricing" },
    { label: "Case studies", href: "/case-studies" },
    { label: "About", href: "/about" },
  ] satisfies NavLink[],

  footer: {
    product: [
      { label: "Product overview", href: "/product" },
      { label: "Pricing", href: "/pricing" },
    ] satisfies NavLink[],
    company: [
      { label: "About", href: "/about" },
      { label: "Case studies", href: "/case-studies" },
      { label: "FAQ", href: "/faq" },
      { label: "Contact", href: "/contact" },
    ] satisfies NavLink[],
    legal: [
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
    ] satisfies NavLink[],
  },

  // PLACEHOLDER social profiles
  social: [
    { label: "LinkedIn", href: "https://www.linkedin.com/", icon: "linkedin" },
    { label: "X", href: "https://x.com/", icon: "x" },
    { label: "GitHub", href: "https://github.com/", icon: "github" },
  ] satisfies SocialLink[],
};
